import React from "react";
import UsersGalleryItem, { TGalleryItem } from "./UsersGalleryItem";
import "./users-gallery.scss";
import Title from "../../atoms/title/title";

export interface IUsersGallery {
  title?: string;
  items: TGalleryItem[];
  fluid?: boolean;
}

const UsersGallery = (props: IUsersGallery) => {
  const { title, items } = props;
  const compClass = "o-usersGallery";
  return (
    <section
      className={`${compClass} ${props.fluid ? compClass + "--fluid" : ""}`}
    >
      <Title titulo={props?.title || "<b>Podcast</b>"} haveInnerHTML={true} />
      <div className={`${compClass}__grid`}>
        {items?.map((item: TGalleryItem) => {
          return (
            <UsersGalleryItem
              key={item.title}
              compClass={compClass}
              title={item.title}
              imgUrl={item.imgUrl}
              links={item.links}
            />
          );
        })}
      </div>
    </section>
  );
};

export default UsersGallery;
